import { render, staticRenderFns } from "./CourseDayItem.vue?vue&type=template&id=669bf14b&lang=pug&"
import script from "./CourseDayItem.vue?vue&type=script&lang=js&"
export * from "./CourseDayItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports